const development = require('./development');

const { env, deploy, logger, elastic } = development;

module.exports = {
  ...development,
  mode: 'production',
  sourceMap: 'source-map',
  urlRoot: `https://${env}.ls-www.localsearch.cloud`,
  v2UrlRoot: `https://${env}.ls-www.localsearch.cloud`,
  logger: {
    ...logger,
    console: {
      level: 'debug',
    },
  },
  serviceApiRoot: `https://${env}.services.lsapis.com.au`,
  serviceGraphqlRoot: `https://${env}.services.lsapis.com.au/graphql`,
  imageResizeRoot: 'https://images.staging.ls-www.localsearch.cloud',
  recaptchaRoot:
    'https://u67big8d6b.execute-api.ap-southeast-2.amazonaws.com/development',
  filemakerApiRoot:
    'https://fmwdz3tq57.execute-api.ap-southeast-2.amazonaws.com/staging',
  elastic: {
    ...elastic,
    node: 'https://es8.elasticsearch-staging.localsearch.cloud',
  },
  bpm: {
    baseUrl: `https://forbusiness.${env}.localsearch.cloud`,
  },
  token: {
    ...development.token,
    cookie: { domain: '.localsearch.cloud' },
  },
  auth: {
    ...development.auth,
    redirectUri: `https://${env}.ls-www.localsearch.cloud/login-loader`,
    returnTo: `https://${env}.ls-www.localsearch.cloud`,
  },
  deploy,
};
